// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbfaba8c","732":"fee565b2","977":"5cb81e48"}[chunkId] + ".chunk.js";
};